import React, { FC, useState } from 'react'
import { BtText } from './BtText'

interface SecureLabelProps {
  value: string
}

export const SecureLabel: FC<SecureLabelProps> = ({ value }) => {
  const [hideValue, setHideValue] = useState(true)

  return (
    <BtText
      size={16}
      weight="700"
      style={{ lineHeight: 26 }}
      onPress={() => setHideValue(!hideValue)}
    >
      {hideValue ? '*'.repeat(value.length) : value}
    </BtText>
  )
}
